module.exports = __webpack_public_path__ + "static/media/picture-6@2x.54fb0e56.png";